import { Validators } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import * as moment from 'moment';

export const frequency_premium_change_form_template = {
  amount: null,
  frequency: null,
};

export const frequency_premium_change_form_validators = {
  amount: [Validators.required],
  frequency: [Validators.required],
};

export const frequency_premium_change_form_keys: IFormKey[] = [
  {
    id: 'premium-field',
    label: 'Importo premio',
    controlName: 'amount',
    css: 'col-6',
    isAmountField: true,
  },
  {
    id: 'frequency-field',
    label: 'Periodicità',
    controlName: 'frequency',
    css: 'col-6',
    type: 'SELECT',
    options: [],
  },
];

export const frequency_premium_change_previdenziali_form_template = {
  variationDate: moment(),
  frequency: null,
  currency: null,
  amount: null,
  requestDay: null,
  requestMonth: null,
};

export const frequency_premium_change_previdenziali_form_validators = {
  variationDate: [Validators.required],
  frequency: [Validators.required],
  currency: [Validators.required],
  amount: [Validators.required],
  requestDay: [Validators.required],
  requestMonth: [Validators.required],
};

export const frequency_premium_change_previdenziali_form_keys: IFormKey[] = [
  {
    id: 'variation-date',
    label: 'Data Variazione',
    controlName: 'variationDate',
    css: 'col-6',
    type: 'DATEPICKER',
    defaultValue: moment().toISOString(),
  },
  {
    id: 'frequency-field',
    label: 'Frazionamento',
    controlName: 'frequency',
    css: 'col-6',
    type: 'SELECT',
  },
  {
    id: 'currency-field',
    label: 'Divisa Competenza',
    controlName: 'currency',
    css: 'col-6',
    type: 'INPUT',
    defaultValue: 'EURO',
    readonly: true,
  },
  {
    id: 'premium-field',
    label: 'Importo Versamento Frazionato',
    controlName: 'amount',
    css: 'col-6',
    isAmountField: true,
    readonly: true,
  },
  {
    id: 'request-day-field',
    label: 'Giorno',
    controlName: 'requestDay',
    css: 'col-6',
    type: 'NUMBER',
    numberMax: 31,
    numberMin: 1
  },
  {
    id: 'request-month-field',
    label: 'Mese',
    controlName: 'requestMonth',
    css: 'col-6',
    type: 'NUMBER',
    numberMax: 12,
    numberMin: 1
  },
];

export const frequency_premium_amount_change_previdenziali_form_template = {
  variationDate: moment(),
  frequency: null,
  currency: null,
  amount: null,
  requestDay: null,
  requestMonth: null,
};

export const frequency_premium_amount_change_previdenziali_form_validators = {
  variationDate: [Validators.required],
  frequency: [Validators.required],
  currency: [Validators.required],
  amount: [Validators.required],
  requestDay: [Validators.required],
  requestMonth: [Validators.required],
};

export const premium_amount_change_previdenziali_form_template = {
  variationDate: moment(),
  frequency: null,
  currency: null,
  amount: null,
};

export const premium_amount_change_previdenziali_form_validators = {
  variationDate: [Validators.required],
  frequency: [Validators.required],
  currency: [Validators.required],
  amount: [Validators.required],
};

export const premium_amount_change_previdenziali_form_keys: IFormKey[] = [
  {
    id: 'variation-date',
    label: 'Data Variazione',
    controlName: 'variationDate',
    css: 'col-6',
    type: 'DATEPICKER',
    defaultValue: moment().toISOString(),
  },
  {
    id: 'frequency-field',
    label: 'Frazionamento',
    controlName: 'frequency',
    css: 'col-6',
    type: 'SELECT',
    options: [],
    readonly: true,
  },
  {
    id: 'currency-field',
    label: 'Divisa Competenza',
    controlName: 'currency',
    css: 'col-6',
    type: 'INPUT',
    defaultValue: 'EURO',
    readonly: true,
  },
  {
    id: 'premium-field',
    label: 'Importo Versamento Frazionato',
    controlName: 'amount',
    css: 'col-6',
    isAmountField: true,
  },
];

export interface IVariazionePremioPeriodicitaRequest {
  policyNumber: string;
  frequency?: string;
  importo?: string;
}

export interface IVariazionePremioPeriodicitaPrevidentialRequest {
  policyNumber: string;
  newFractionationCode: string;
  variationDate: string;
  newGrossAmount: string;
  requestDay: string;
  requestMonth: string;
}

export enum EVariationOptions {
  PRIZE = 'PRIZE',
  FREQUENCY = 'FREQUENCY'
}

export const variation_options_form_template = {
  variationOptions: null
}
export const variation_options_form_validators = {
  variationOptions: [Validators.required]
}

export const variation_options_form_keys: IFormKey[] = [
  {
    id: 'variation-options-field',
    controlName: 'variationOptions',
    label: 'Opzioni Variazione',
    css: 'col-4',
    type: 'SELECT',
    options: [
      {
        key: 'PRIZE',
        value: 'Premio'
      },
      {
        key: 'FREQUENCY',
        value: 'Rateazione'
      }
    ]
  }
]
